import { clearGuestSessionFlag } from './sessionGuest.ts'

type PersistAccessParams = {
  access_token: string
}

export const persistAccessTokenStorageOnly = (access_token: string): void => {
  localStorage.setItem('access-Token-Edify', access_token)
  localStorage.removeItem('access-RefreshToken-Edify')
}

export const persistLoginTokens = ({ access_token }: PersistAccessParams): void => {
  persistAccessTokenStorageOnly(access_token)
  clearGuestSessionFlag()
}
